'use strict';

/**
 * Режим сжатия группы кнопок.
 * @since 5.0.0.4104
 * @readonly
 * @enum {string} GROUP_FOLD_MODE
 * @example
 * //В группе кнопок, именуемой ATTACHMENTS, убрать подписи у маленьких кнопок.
 * WebAccess.current.toolBar.groups.ATTACHMENTS.compress(GROUP_FOLD_MODE.SHRINK_SMALL_BUTTONS);
 */
var GROUP_FOLD_MODE = {
  /** Убрать подписи у маленьких кнопок */
  SHRINK_SMALL_BUTTONS: 0,
  /** Преобразовать большие кнопки в столбец из маленьких */
  CONVERT_LARGE_BUTTONS: 1,
  /** Свернуть группу, состоящую из маленьких кнопок, в одну большую кнопку */
  COLLAPSE: 2,
  /** Свернуть группу кнопок по приоритету: CONVERT_LARGE_BUTTONS > SHRINK_SMALL_BUTTONS > COLLAPSE */
  AUTO: 3
};

// Время ожидания скрытия группы на ленте тулбара.
const autoHideTimeout = 500;

/**
 * Группа панели инструментов.
 *
 * @class WebAccess.components.wrappers.toolBar.ToolBarGroup
 * @extends WebAccess.components.wrappers.BasePageElement
 * @property {string} name Имя группы
 * @property {string} priority Приоритет сворачивания группы
 * @property {string} selector Путь в DOM-иерархии к объекту группы, например div.content#container
 * @param {string} itemSelector Существующий элемент страницы
 * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup}
 */

(function (global) {
  var toolBarContainerSelector = '#toolbar_container';
  var groupSelector = 'div.toolbar_group';
  var groupHeaderSelector = 'div.toolbar_group_header, div.toolbar-more-button__header';
  const buttonSelector = 'div.toolbar_button';
  var smallButtonSelector = 'div.small_toolbar_item';
  var jToolBarContainer = $(toolBarContainerSelector);
  var toolBarBottomBorderClass = 'toolbar_bottom_border';
  var buttonArrowSelector = '.toolbar-item__arrow';


  global.index = 100;

  /**
   * Группа кнопок на тулбаре.
   *
   * @extends WebAccess.components.wrappers.BasePageElement
   */
  var ToolBarGroup = global.components.wrappers.BasePageElement.extend({

    /**
     * Конструктор.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#init
     * @param {object} itemSelector - jQuery-селектор объекта для группы.
     * @override
     */
    init: function (itemSelector) {
      this._super(itemSelector);
      this.selector = format(this._byNameSelectorTemplate, groupSelector, this.name);
      this._index = global.index += 1;
      this.priority = this._jObject.attr('priority');

      if (this._jObject.attr('iscollapsed') === 'True') {
        this._isCollapsed = this._isCollapsedOnExtension = true;
        this._bindHeaderClick();
      }
    },

    /**
     * Имя класса.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ToolBarGroup#className
     * @override
     */
    className: 'ToolBarGroup',

    /**
     * Признак свернутой группы.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ToolBarGroup#_isCollapsed
     */
    _isCollapsed: false,
    /**
     * Признак группы, свернутой в веб-модуле.
     * Такие группы не должны разворачиваться.
     *
     * @private
     * @property WebAccess.components.wrappers.toolBar.ToolBarGroup#_isCollapsedOnExtension
     */
    _isCollapsedOnExtension: false,

    /**
     * Приоритет группы кнопок на ленте.
     *
     * @private
     * @property WebAccess.components.wrappers.BasePageElement#priority
     */
    priority: null,

    /**
     * jQuery-селектор элемента страницы.
     *
     * @private
     * @property WebAccess.components.wrappers.BasePageElement#selector
     * @deprecated since 5.6.
     */
    selector: '',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /** @private */
    _index: 0,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установить обработчик нажатия на заголовок группы.
     *
     * @private
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#_bindHeaderClick
     */
    _bindHeaderClick: function () {
      var me = this;
      var headerInlineBlock = 'inline-block';
      var addedGroupSelector = 'div[id^=\'addedDiv\']';
      var tbgroup_header = this._jObject.children(groupHeaderSelector);
      tbgroup_header.css('display', headerInlineBlock).unbind('click').bind('click', function (evt) {
        evt.stopPropagation();
        var elem = $(this).nextAll(addedGroupSelector);
        if (elem.css('display') !== 'none') {
          elem.hide();
        } else {
          var docWidth = $(document).width();
          $(addedGroupSelector).hide();
          elem.show();
          var jHiddenDiv = me._jObject.find('.addedHiddenDiv:visible').css('left', '');
          var divWidth = jHiddenDiv.width();
          if (divWidth > (docWidth - jHiddenDiv.position().left)) jHiddenDiv.css('left', docWidth - divWidth);
        }
      });

      tbgroup_header.nextAll(buttonSelector).hover(function () {
        $(this).addClass('hover');
      }, function () {
        $(this).removeClass('hover');
      });

      me._autoHideGroup($('.addedHiddenDiv'));
    },

    /**
     * Создать кнопку в текущей группе.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#createButton
     * @param {string} buttonName Имя создаваемой кнопки.
     * @param {BUTTON} [opt_smallSized] Отображение или скрытие заголовка кнопки.
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
     */
    createButton: function (buttonName, opt_smallSized) {
      return global.current.toolBar.buttons.create(this.name, buttonName, opt_smallSized);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сворачивание группы кнопок
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#collapse
     * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup}
     */
    collapse: function () {
      var me = this;
      if (!me.isCollapsed()) {
        var addedGroupSelector = 'div[id^=\'addedDiv\']';

        jToolBarContainer.find(addedGroupSelector + ':visible').hide();
        const jVisibleButtons = me._jObject.children(buttonSelector).filter(':visible');
        const jButtonArrows = jVisibleButtons.find(buttonArrowSelector);
        //Нельзя сворачивать группы из одной кнопки. А также нельзя скрывать группы с кнопками со стрелками, чтобы не получилось многоуровневое меню.
        if (jVisibleButtons.length > 1 && !jButtonArrows.length) {
          me._jObject.append(format(CT.toolBar.groupCollapsed, me._jObject.css('left')));
          //Сначала добавляем div выше, потом только биндить клик
          me._bindHeaderClick();

          var jAddedDiv = me._jObject.find('#addedDiv');
          jVisibleButtons.appendTo(jAddedDiv);
          fixSvg(jAddedDiv[0]);

          me._isCollapsed = true;
          me.fire(WebAccess.components.wrappers.toolBar.ToolBarGroup.EVENTS.COLLAPSE);

          jVisibleButtons.hover(function () {
            $(me).addClass('hover');
          }, function () {
            $(me).removeClass('hover');
          });
        } else {
          return me;
        }
      }
      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//      

    /**
     * Автоскрытие группы, когда мышь находится вне её.
     *
     * @private
     * @since 5.0.0.4212
     */
    _autoHideGroup(jGroup) {
      let autohide;
      jGroup
        .off('mouseenter.collapse')
        .off('mouseleave.collapse')
        .on('mouseenter.collapse', () => {
          if (autohide) {
            clearTimeout(autohide);
          }
        })
        .on('mouseleave.collapse', () => {
          autohide = setTimeout(() => {
            jGroup.hide();
          }, autoHideTimeout);
        });
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Развернуть кнопки группы.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#expand
     * @returns {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
     */
    expand: function () {
      if (this.isCollapsed()) {
        const jAddedDiv = this._jObject.find('#addedDiv');
        let items = jAddedDiv.children(buttonSelector);
        items.appendTo(this._jObject);
        fixSvg(this._jObject[0]);
        jAddedDiv.remove(); //удалять надо после вставки в другое место иначе теряются обработчики событий.

        this._jObject.children('.toolbar_group_header').css('display', 'none');

        setRealHeightAndWidth();
        var jSmallItems = items.find('.small_toolbar_item');
        items.add(jSmallItems).hover(function () {
          if (!$(this).hasClass('disabled')) {
            $(this).addClass('hover');
          }
        }, function () {
          if (!$(this).hasClass('disabled')) {
            $(this).removeClass('hover');
          }
        });
        this._isCollapsed = false;
        this.fire(WebAccess.components.wrappers.toolBar.ToolBarGroup.EVENTS.EXPAND);
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак свернутой группы.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#isCollapsed
     * @return {boolean} True, если группа свернута, иначе False.
     */
    isCollapsed: function () {
      return this._isCollapsed; //this._jObject.children(groupHeaderSelector).is(":visible");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Имитирует щелчок мыши на кнопке свернутой группы.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#click
     * @param {function} opt_callback Функция, которая будет вызвана по щелчку мыши.
     * @throws ERR_CANT_CLICK_ON_EXPANDED_GROUP – метод click поддерживается только для свернутых групп.
     * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
     */
    click: function (opt_callback) {
      var jHeader = this._jObject.children(groupHeaderSelector);

      if (this.isCollapsed()) {
        if ($.isFunction(opt_callback)) {
          this._disableClickHandler(jHeader);
          this.bind('click', opt_callback);
          this.jHeader.bind('click', function () {
            instance.fire('click');
          });
        } else jHeader.click();
      } else global.raise('ERR_CANT_CLICK_ON_EXPANDED_GROUP');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить список кнопок текущей группы.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#getButtons
     * @return {WebAccess.current.toolBar.buttons} Список объектов типа ToolBarButton, вложенных в эту группу.
     */
    getButtons: function () {
      var me = this;
      var buttons = global.current.toolBar.buttons.toArray();
      var filteredButtons = {};
      var filtered = _(buttons).filter(function (button) {
        return button.groupName === me.name;
      });
      for (var buttonName in filtered) {
        filteredButtons[filtered[buttonName].name] = filtered[buttonName];
      }
      return new WA.Collection(filteredButtons);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

    /**
     * Добавить нижнюю границу к текущей группе.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#addBottomBorder
     * @param {string} color CSS-класс цвета нижней границы
     * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
     * @since 5.0.0.4200
     * @deprecated since 5.6.
     */
    addBottomBorder(color) {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      var me = this;
      var jBottomBorder = me._jObject.children('.' + toolBarBottomBorderClass);
      if (!jBottomBorder.length) {
        // Дополнительный div нужен что бы сделать ему position:relative, 
        // т.к. у toolbar_group этого сделать нельзя, потому что ломается выпадающий список сгруппированных кнопок.
        // А вообще position:relative нужен что бы в IE7 нормально заработало.
        jBottomBorder = $('<div><div></div></div>');
        me._jObject.prepend(jBottomBorder);
      }
      jBottomBorder.removeClass().addClass(toolBarBottomBorderClass + ' ' + color);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    // Deprecated методы
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить ширину группы.
     *
     * @deprecated since 5.6.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#getWidth
     * @return {number} Ширина группы.
     * @since 5.0.0.4104
     */
    getWidth() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this._jObject.width();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Пошагово сжать группу кнопок.
     *
     * @deprecated since 5.6.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#fold
     * @returns {boolean} Результат сжатия - FALSE.
     * @since 5.0.0.4104
     */
    fold() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Пошагово восстановить группы кнопок.
     *
     * @deprecated since 5.6.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#unfold
     * @returns {boolean} Результат восстановления - FALSE.
     * @since 5.0.0.4104
     */
    unfold() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Сжать группу в указанный размер.
     *
     * @deprecated since 5.6.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#fitToWidth
     * @param {number} width Ширина, в которую необходимо вписать группу.
     * @returns {boolean} TRUE, если группа вмещается в указанную ширину, иначе - FALSE.
     * @since 5.0.0.4104
     */
    fitToWidth(width) {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this.getWidth() <= width;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Скрыть следующий за группой разделитель.
     *
     * @deprecated since 5.6.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#hideNextSeparator
     * @returns {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
     * @since 5.0.0.4212
     */
    hideNextSeparator() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//   

    /**
     * Показать следующий за группой разделитель.
     *
     * @deprecated since 5.6.
     * @method WebAccess.components.wrappers.toolBar.ToolBarGroup#showNextSeparator
     * @returns {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа ToolBarGroup.
     * @since 5.0.0.4212
     */
    showNextSeparator() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  }, {
    EVENTS: {
      CHANGE: 'change',
      COLLAPSE: 'collapse',
      EXPAND: 'expand'
    }
  });

  global.components.wrappers.toolBar.ToolBarGroup = ToolBarGroup;
})(window.WebAccess);